// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Animation_container__1S6y1 {\n  overflow: hidden;\n  padding: 0rem 2rem 2rem;\n  color: var(--color-landing);\n}\n", "",{"version":3,"sources":["webpack://src/Landing/Animation/Animation.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B","sourcesContent":[".container {\n  overflow: hidden;\n  padding: 0rem 2rem 2rem;\n  color: var(--color-landing);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Animation_container__1S6y1"
};
export default ___CSS_LOADER_EXPORT___;
